import { render, staticRenderFns } from "./MenuRelatoriosValeTransporte.vue?vue&type=template&id=239de492"
import script from "./MenuRelatoriosValeTransporte.vue?vue&type=script&lang=ts"
export * from "./MenuRelatoriosValeTransporte.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports